import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import CreditList from '@/plugins/graphql/queries/v2/grab-express-topup-list.gql';
import { CreditModel } from '@/helpers/entities/models/CreditModel';
import { Getter } from 'vuex-class';
let CreditsManager = class CreditsManager extends Mixins() {
    constructor() {
        super(...arguments);
        this.credits = [];
    }
};
__decorate([
    Getter('appUuid')
], CreditsManager.prototype, "appUuid", void 0);
CreditsManager = __decorate([
    Component({
        apollo: {
            credits: {
                query: CreditList,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                update(data) {
                    if (data.grabExpressTopupList) {
                        const credits = data.grabExpressTopupList.edges;
                        const creditsNodes = (credit) => {
                            return new CreditModel(credit.node);
                        };
                        return credits.map(creditsNodes);
                    }
                    return [];
                },
            },
        },
    })
], CreditsManager);
export default CreditsManager;
